import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import NavBarLandingPage from '../../components/pages/NavBarLandingPage';
import FooterLandingpage from '../../components/pages/FooterLandingpage';


// ----------------------------------------------------------------------

export default function CompactLayout({ children }) {
  return (
    <>
      <NavBarLandingPage />

      <Container component="main">
        <Stack
          sx={{
            py: 2,
            m: 'auto',
            maxWidth: 520,
            minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
      <FooterLandingpage />
    </>
  );
}

CompactLayout.propTypes = {
  children: PropTypes.node,
};
